import { AssociatedMediasResource, AssociatedMediasoid } from "@skinsoft/types"

export function cleanRefs(obj) {
    if (obj && typeof obj === 'object') {
        if (obj.ref) {
            return obj.ref
        }
        let keys = Object.keys(obj)
        const clean = {}
        for (const field of keys) {
            if (Array.isArray(obj[field])) {
                clean[field] = obj[field].map(e => cleanRefs(e))
            } else if (typeof obj[field] === 'object') {
                clean[field] = cleanRefs(obj[field])
            } else {
                clean[field] = obj[field]
            }
        }

        return clean
    }

    return obj
}

export function cleanValueToSort(obj) {
    if (obj && typeof obj === 'object') {
        if (obj.value && obj.valueToSort) {
            return obj.value
        }
        let keys = Object.keys(obj)
        const clean = {}
        for (const field of keys) {
            if (Array.isArray(obj[field])) {
                clean[field] = obj[field].map(e => cleanValueToSort(e))
            } else if (typeof obj[field] === 'object') {
                clean[field] = cleanValueToSort(obj[field])
            } else {
                clean[field] = obj[field]
            }
        }

        return clean
    }

    return obj
}

export function cleanAssociatedMedias(associatedMedias: AssociatedMediasoid): AssociatedMediasResource {
    let res: AssociatedMediasResource = {}
    
    if(associatedMedias) {
        if(associatedMedias.first?.ref) {
            res.first = associatedMedias.first.ref
        }
        if(associatedMedias.second?.ref) {
            res.second = associatedMedias.second.ref
        }
        if(associatedMedias.third?.ref) {
            res.third = associatedMedias.third.ref
        }

        if(associatedMedias.medias?.length) {
            res.medias = associatedMedias.medias.map(media => {
                if(media.ref) {
                    return media.ref
                }

                return media
            })
        }
    }

    return res
}